// CookieConsent.js
import React, { useState, useEffect } from "react";
import { Cliente } from '../global';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setVisible(false);
  };

  const handleClose = () => {
    setVisible(false); // Apenas fecha o banner sem salvar consentimento
  };

  if (!visible) return null;

  return (
    <>
      {/* Overlay branco semi-transparente */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          zIndex: 1000,
        }}
      ></div>

      {/* Banner de cookies */}
      <div
        style={{
          position: "fixed",
          bottom: "15px",
          left: "15px",
          maxWidth: "50%",
          backgroundColor: "rgb(240, 242, 245)",
          borderRadius: "8px",
          padding: "20px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          fontFamily: "'Arial', sans-serif",
          zIndex: 1001,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
          <div>
            <strong style={{ fontSize: "16px", display: "block", marginBottom: "8px" }}>
              Faça a gestão dos seus cookies
            </strong>
            <p style={{ fontSize: "14px", color: "#333", margin: 0, textAlign: 'justify' }}>
              <b>{Cliente}</b>, utilizamos alguns cookies essenciais para melhorar sua experiência por aqui.
              Ao aceitar, você nos ajuda a deixar nosso site cada vez melhor.
            </p>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              marginLeft: "10px",
              color: "#999",
            }}
          >
            ×
          </button>
        </div>
        <div style={{ marginTop: "15px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <button
            onClick={handleReject}
            style={{
              padding: "6px 12px",
              fontSize: "14px",
              backgroundColor: "#f5f5f5",
              border: "1px solid #ccc",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Recusar todos
          </button>
          <button
            onClick={handleAccept}
            style={{
              padding: "6px 12px",
              fontSize: "14px",
              backgroundColor: "#1890ff",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Aceitar
          </button>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
